export default function (...args)
{
	return {

		display_mask(match)
		{
			return match.replaceAll('|', '\n');
		},

		setValue(value, _this = this)
		{
			this.safeProtoCall(value?.replaceAll('\n', '|'), _this);
		},

		handleEvents(ev, _this = this)
		{
			if (ev.type == 'keydown' && ev.key == 'Enter' && ev.ctrlKey)
			{
				let node = document.querySelector(this.selector);
				let cursor = node.selectionStart + 1;
				node.value = node.value.slice(0, node.selectionStart) + '\n' + node.value.slice(node.selectionEnd);
				node.setSelectionRange(cursor, cursor);
				ev.preventDefault();
				ev.stopPropagation();
			}
			this.safeProtoCall(ev, _this);
		}

	};
}

